/*
 *
 * App actions
 *
 */
import {
  CREATE_DENTIST_ACTION,
  CREATE_PATIENT_ACTION,
  DEFAULT_ACTION,
  DELETE_DENTIST_ACTION,
  FILTER_DENTIST,
  FILTER_PATIENTS_ACTION,
  GET_ACTIVE_START_DATE,
  GET_DENTISTS_ACTION,
  GET_END_PRODUCTS,
  GET_INSURERS_ACTION,
  GET_PLANNED_TIMESLOTS,
  GET_PRACTICE_MESSAGES,
  GET_PRACTICE_MESSAGES_ERROR,
  GET_PRACTICE_MESSAGES_SUCCESS,
  GET_PRACTICE_PRODUCT_ORDERS,
  GET_PRACTICE_PRODUCT_ORDERS_ERROR,
  GET_PRACTICE_PRODUCT_ORDERS_SUCCESS,
  GET_PRODUCT_ORDERS_ACTION,
  GET_TREATMENTS_ACTION,
  NEXT_MONTH,
  PREVIOUS_MONTH,
  PURGE_DELETED_TIME_SLOTS,
  REMOVE_TIME_SLOT,
  RESET_DELETE_MESSAGE,
  RESET_DENTISTS,
  RESET_PATIENTS,
  SET_DATE,
  SET_SINGLE_PRACTICE,
} from "./constants";

function noop() {}

export function defaultAction() {
  return {
    type: DEFAULT_ACTION,
  };
}

export function filterPatientsAction(filterText) {
  return {
    type: FILTER_PATIENTS_ACTION,
    filterText,
  };
}

export function getEndProductTypesAction() {
  return {
    type: GET_END_PRODUCTS,
  };
}

export function filterDentistAction(filterText) {
  return {
    type: FILTER_DENTIST,
    filterText,
  };
}

export function getPlannedTimeSlotsAction(callback = noop) {
  return {
    type: GET_PLANNED_TIMESLOTS,
    callback,
  };
}

export function resetPatients() {
  return {
    type: RESET_PATIENTS,
  };
}

export function getDentistActionApp() {
  return {
    type: GET_DENTISTS_ACTION,
  };
}

export function resetDentists() {
  return {
    type: RESET_DENTISTS,
  };
}

export function removePlannedTimeSlot(timeSlot) {
  return {
    type: REMOVE_TIME_SLOT,
    timeSlot,
  };
}

export function purgeDeleteTimeSlotsAction() {
  return {
    type: PURGE_DELETED_TIME_SLOTS,
  };
}

export function createPatientAction(patient, callback, existing) {
  return {
    type: CREATE_PATIENT_ACTION,
    patient,
    callback,
    existing,
  };
}

export function createDentistAction(dentist, callback, existing) {
  return {
    type: CREATE_DENTIST_ACTION,
    dentist,
    callback,
    existing,
  };
}

export function deleteDentistAction(dentist) {
  return {
    type: DELETE_DENTIST_ACTION,
    dentist,
  };
}

export function resetDentistDeleteMessage() {
  return {
    type: RESET_DELETE_MESSAGE,
  };
}

export function setSinglePracticeAction(value) {
  return {
    type: SET_SINGLE_PRACTICE,
    value,
  };
}

export function getTreatmentsAction() {
  return {
    type: GET_TREATMENTS_ACTION,
  };
}

export function getProductOrdersAction() {
  return {
    type: GET_PRODUCT_ORDERS_ACTION,
  };
}

export function getInsurersActionApp() {
  return {
    type: GET_INSURERS_ACTION,
  };
}

export function getActiveStartDate({ activeStartDate }) {
  return {
    type: GET_ACTIVE_START_DATE,
    activeStartDate,
  };
}

export function setDate(date) {
  return {
    type: SET_DATE,
    date,
  };
}

export function nextMonth() {
  return {
    type: NEXT_MONTH,
  };
}

export function previousMonth() {
  return {
    type: PREVIOUS_MONTH,
  };
}

export function getPracticeMessages({ limit, offset, filter, status }) {
  return {
    type: GET_PRACTICE_MESSAGES,
    limit,
    offset,
    filter,
    status,
  };
}
export function getPracticeMessagesSuccess({ messages, statusOpenCount }) {
  return {
    type: GET_PRACTICE_MESSAGES_SUCCESS,
    messages,
    statusOpenCount,
  };
}
export function getPracticeMessagesError({ error }) {
  return {
    type: GET_PRACTICE_MESSAGES_ERROR,
    error,
  };
}

export function getPracticeProductOrders() {
  return {
    type: GET_PRACTICE_PRODUCT_ORDERS,
  };
}

export function getPracticeProductOrdersSuccess(data) {
  return {
    type: GET_PRACTICE_PRODUCT_ORDERS_SUCCESS,
    data,
  };
}

export function getPracticeProductOrdersError(error) {
  return {
    type: GET_PRACTICE_PRODUCT_ORDERS_ERROR,
    error,
  };
}
